import Grid from "@mui/material/Grid";
import { GetProjectResponse } from "api/generatedApi";
import { CardWithHeaderAndFooter } from "components/shared/card/card-header-footer";
import { ShowStringDialog } from "components/shared/show-string-dialog/show-string-dialog";
import { useTranslation } from "react-i18next";
import { useDialog } from "shared/dialog/use-dialog";
import { useDashboardRestrictions } from "shared/user-restrictions/use-dashboard-restrictions";
import { ProjectTypeAndInfoContent } from "./project-type-and-info-content";
import { useEditProjectTypeAndInfo } from "components/page/projects/project-setup/edit-project-type-and-info-dialog/hooks/use-edit-project-type-and-info";

interface Props {
  project: GetProjectResponse;
  usePrintLayout?: boolean;
}

export const ProjectTypeAndInfo = ({ project, usePrintLayout }: Props) => {
  const { t } = useTranslation();
  const editProjectTypeAndInfo = useEditProjectTypeAndInfo({ project });
  const { canEditProjectSetupProjectName } = useDashboardRestrictions(project);
  const [openDescriptionDialog] = useDialog(ShowStringDialog);

  const hasDescription = (): boolean => {
    return (project.description ?? "").length > 0;
  };

  const viewDescription = () => {
    if (hasDescription() && project.description) {
      openDescriptionDialog({ stringValue: project.description, header: "common.description" });
    }
  };

  return (
    <Grid item xs={12} lg={4} xl={4} display={"flex"} justifyContent={"center"}>
      <CardWithHeaderAndFooter
        titleNamespace={t("dashboard.projectInfo.projectTypeAndInfo.title")}
        description={""}
        height={"420px"}
        headerActionIcon={undefined}
        showHeaderAction={canEditProjectSetupProjectName()}
        showBottomAction={"none"}
        headerActionClickedProps={editProjectTypeAndInfo}
        bottomActionClickedProps={viewDescription}
        showContent={true}
        noContentText={""}
        showDescription={false}
        hasChildPadding={false}
        titleLeftPadding="30px"
      >
        <ProjectTypeAndInfoContent project={project} usePrintLayout={false} />
      </CardWithHeaderAndFooter>
    </Grid>
  );
};
